export default __webpack_public_path__ + "static/media/541.d0f566b7.svg";